import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { _setAxios } from '../../lib/Helper';

async function fetchList(tahunAjaranId, tingkatanKelas) {

  if (!tahunAjaranId || !tingkatanKelas) {
    return []
  }

  return await _setAxios("keuangan/pemasukan/detail/dropdown", "POST", {
    tahun_ajaran_id: tahunAjaranId,
    tingkatan_kelas: tingkatanKelas
  })
    .then(body => {
      let results = []
      body.data?.data?.forEach(row => {
        results.push({
          label: row.pos_pemasukan_nama,
          value: row.pemasukan_detail_id,
          nominal_tagihan: row.nominal
        })
      });

      return results
    })
}

const SelectBiaya = ({ ...props }) => {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    fetchList(props.tahunAjaranId, props.tingkatanKelas).then((newOptions) => {
      setOptions(newOptions);
    });
  }, [props.tahunAjaranId, props.tingkatanKelas]);

  return (
    <Select
      {...props}
      fetchOptions={fetchList}
      placeholder="Pilih biaya"
      style={{
        width: '100%',
      }}
      options={options}
    />
  );
};
export default SelectBiaya;
